import React from "react";

import DatabaseGroupSelect from "./DatabaseGroupSelect";
import DatabaseSelect from "./DatabaseSelect";
import ServerSelect from "./ServerSelect";

import styles from "./style.module.scss";
import {
  useCurrentOrganization,
  useCurrentServer,
  useCurrentServerGroup,
} from "components/WithCurrentOrganization";
import classNames from "classnames";

type Props = {
  className?: string;
  pageControls?: React.ReactNode;
};

const PageHeaderNav: React.FunctionComponent<Props> = ({
  className,
  pageControls,
}) => {
  return (
    <div className={classNames(className, styles.headerNav)}>
      <PageHeaderNavSelects />
      {pageControls && <div>{pageControls}</div>}
    </div>
  );
};

const PageHeaderNavSelects: React.FunctionComponent = () => {
  const currentOrganization = useCurrentOrganization(true);
  const currentServer = useCurrentServer(true);
  const currentServerGroup = useCurrentServerGroup(true);
  if (!currentOrganization) {
    return null;
  }
  const { servers, serverGroups, permittedToCreateServers } =
    currentOrganization;

  if (
    serverGroups.length === 0 &&
    servers.length === 0 &&
    !permittedToCreateServers
  ) {
    return null;
  }

  return (
    <div className={styles.selectContainer}>
      <ServerSelect
        servers={servers}
        serverGroups={serverGroups}
        organizationSlug={currentOrganization.slug}
        currentServerId={currentServer?.humanId}
        currentServerGroupId={currentServerGroup?.id}
      />
      {currentServer ? (
        <DatabaseSelect />
      ) : currentServerGroup ? (
        <DatabaseGroupSelect />
      ) : null}
    </div>
  );
};

export default PageHeaderNav;
